import { slideToggle } from '../helpers/element/slide';
import { nextUntil } from '../helpers/element/nextUntil';

class InfoItemAccordion {
    constructor() {
        this.root = null;
        this.container = null;
        this.parent = null;
        this.wrapper = document.createElement('div');
        this.questions = [];

        this.getElements();

        if (this.canInit()) {
            this.createAccordion();
        }
    }

    getElements() {
        this.root = document.querySelector('.info-item:not(.info-item--explore)');

        if (this.root !== null) {
            this.container = this.root.querySelector('.info-item-content__column--content');
            this.parent = this.container.querySelector('.info-item-content__content');
            this.questions = this.container.querySelectorAll('h2');
        }
    }

    canInit() {
        return this.container !== null && this.parent !== null && this.questions.length > 0;
    }

    createAccordion() {
        this.handleQuestions();
    }

    handleQuestions() {
        this.questions.forEach((question, i) => {
            question.setAttribute("id", `question-${i}`);
            question.classList.add("question");
        });

        this.questions.forEach((question, i) => {
            // Create id selector for next h2 tag
            const nextId = i + 1;

            // Select content between h2 tags
            // const answerContent = document.querySelector(`#question-${i}`).childNodes;
            const questionContent = document.querySelector(`#question-${i}`);
            const answerContent = nextUntil(questionContent, `#question-${nextId}`);

            // Create a wrapper div for content between h2 tags
            const answerWrapper = document.createElement('div');
            answerWrapper.setAttribute("id", `answer-${i}`);
            answerWrapper.setAttribute("class", "answer");

            // Iterate through items between h2 tags and append items to wrapper div
            for (let j = 0; j < answerContent.length; j += 1) {
                answerWrapper.appendChild(answerContent[j]);
            }

            // Add wrapped elements to new info post container
            this.wrapper.appendChild(question);
            this.wrapper.appendChild(answerWrapper);

            // Register click event to all titles (h2 tags)
            question.addEventListener('click', (event) => {
                event.preventDefault();
                const questionTarget = event.currentTarget;
                let questionId = questionTarget.getAttribute('id');
                questionId = questionId.replace("question", "#question");

                const answerId = questionId.replace("question", "answer");
                const answerElem = document.querySelector(answerId);
                const questionElem = document.querySelector(questionId);

                // Animate/reveal content
                if (answerElem.childNodes.length > 0) {
                    slideToggle(answerElem);
                    answerElem.classList.toggle('answer-revealed');
                    questionElem.classList.toggle('has-expanded');
                }
            });
        });

        while (this.wrapper.childNodes.length > 0) {
            this.parent.appendChild(this.wrapper.childNodes[0]);
        }
    }
}

// new InfoItemAccordion(); // eslint-disable-line no-new
